const FieldErrorWrapper = ({ className, errorMessage, name }) =>
  typeof errorMessage === "string" ? (
    <div
      data-error-for={name}
      className={className || "unchained-form-field__error"}
    >
      ({errorMessage})
    </div>
  ) : null;

export default FieldErrorWrapper;
